import Studenthouse1 from "./studenthouse (1).webp";
import Studenthouse2 from "./studenthouse (2).webp";
import Studenthouse3 from "./studenthouse (3).webp";

const studenthouse = [Studenthouse1, Studenthouse2, Studenthouse3];

export default studenthouse;
